import { FilterId } from '../../filters/types/filters';

export type EntityTypeForAI =
  | 'company'
  | 'industry'
  | 'geography'
  | 'role'
  | 'skill'
  | 'activity';

/**
 * Derive entity type from the primary filter (e.g. for AI dashboard/report builder).
 * Shared by DashboardEditableGrid and ReportEditableGrid.
 */
export function getEntityTypeFromPrimaryFilter(
  primaryFilter: { id: string } | null | undefined
): EntityTypeForAI | null {
  if (!primaryFilter) return null;
  const filterId = primaryFilter.id;
  if (filterId === FilterId.COMPANY) return 'company';
  if (filterId === FilterId.INDUSTRY) return 'industry';
  if (filterId === FilterId.GEOGRAPHY) return 'geography';
  if (filterId === FilterId.ROLE) return 'role';
  if (filterId === FilterId.CUSTOM_SKILL) return 'skill';
  if (filterId === FilterId.ACTIVITY) return 'activity';
  return null;
}
